/* @flow */
import * as React from 'react';

import { Flex } from '@sonyged/proc-ui';
import css from '@styled-system/css';
import styled from 'styled-components';

import { HEIGHT, WIDTH } from './constant';
import { Pizza } from '../../../pizza/fields/domain/pizza';
import AutoScaleContainer from '../../../pizza/fields/AutoScaleContainer';
import PizzaContainer from '../../../pizza/fields/PizzaContainer';

type Props = {
  pizza: Pizza,
  scale: number,
};

const W_H_RATE = 2.1;

export function PizzaPoster(props: Props) {
  let { scale, pizza } = props;

  const style = React.useMemo(() => {
    let top = HEIGHT * 0.51 * scale;
    let left = 0.3 * WIDTH * scale;
    let height = HEIGHT * 0.065 * scale;
    let width = height * W_H_RATE;
    return {
      position: 'absolute',
      top,
      left,
      width,
      height,
    };
  }, [scale]);

  return (
    <Container style={style}>
      <AutoScaleContainer preferedHeight={600} preferedMinHeight={600} preferedWidth={1080} preferedMinWidth={1080}>
        <PizzaContainer pizza={pizza} />
      </AutoScaleContainer>
    </Container>
  );
}

const Container = styled(Flex)(
  css({
    '&&& .pizza-container': {
      top: 0,
      left: 0,
      right: 0,
      size: '100%',
    },
  })
);
